import Footer from "../footer";
import HeaderNav from "../headerNav";

import "./index.scss";

import academia4 from "../../img/academia/academia4.webp";
import academia6 from "../../img/academia/academia6.webp";
import academia7 from "../../img/academia/academia7.webp";

const About = () => {
  return (
    <>
      <section>
        <HeaderNav />
      </section>

      <section className="container-about">
        <div>
          <h2>Quem somos nós?</h2>
          <div>
            <img className="imageAbout" src={academia4} alt="foto" />
          </div>
          <p>
            <span>Academia StackX</span> é uma instituição de excelência em
            saúde, bem-estar e performance física, dedicada a oferecer soluções
            completas para o desenvolvimento físico e mental de seus clientes.
            Contamos com infraestrutura moderna, equipamentos de última geração
            e profissionais altamente capacitados, comprometidos em proporcionar
            treinos personalizados, acompanhamento técnico especializado e
            programas inovadores de condicionamento físico. Nosso compromisso é
            com resultados consistentes, segurança e satisfação, promovendo um
            ambiente motivador e inspirador para todos os níveis de prática, do
            iniciante ao atleta avançado.
          </p>
        </div>
      </section>

      <section className="container-about">
        <div>
          <h2>Ambiente</h2>
          <div>
            <img
              className="imageAbout"
              src={academia6}
              alt="foto"
              loading="lazy"
            />
          </div>
          <p>
            Nossa estrutura inclui zonas específicas para musculação, cardio,
            aulas coletivas e treinamento funcional, sempre com equipamentos de
            última geração e um layout que facilita a circulação e a prática
            segura das atividades. Além disso, a academia prioriza a limpeza, a
            organização e uma atmosfera motivadora, criando um espaço inspirador
            que incentiva o desenvolvimento físico e o bem-estar integral.
          </p>
        </div>
      </section>

      <section className="container-about">
        <div>
          <h2>Tudo que voçê precisa</h2>
          <div>
            <img className="imageAbout" src={academia7} alt="foto" />
          </div>
          <p>
            Na <span>Academia StackX</span>, oferecemos mais do que treinos —
            proporcionamos uma experiência completa de saúde, performance e
            bem-estar. Com um ambiente moderno, seguro e motivador,
            profissionais qualificados e equipamentos de última geração, cada
            treino é pensado para entregar resultados reais, inspirar superação
            e transformar seu estilo de vida. Aqui, seu objetivo se torna nossa
            prioridade.
          </p>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default About;
